import { Typography } from '@mui/material'
import React from 'react'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import './Calculations.css'


ChartJS.register(ArcElement, Tooltip, Legend);

const Result = ({data}) => {

    const {homeValue, downPayment, interestTimeY, interestTimeM, interestRate, paymentType} = data

    const mortgageAmount = homeValue - downPayment

    const totalLoanMonths = interestTimeY*12 + interestTimeM
    const monthlyInterest = interestRate / 100 / 12

    const monthlyPayment = (
        (mortgageAmount * monthlyInterest * (1 + monthlyInterest) ** totalLoanMonths) / ((1 + monthlyInterest) ** totalLoanMonths - 1)
    );

    const yearlyPayment = monthlyPayment * 12

    const totalInterestGenerated = monthlyPayment * totalLoanMonths - mortgageAmount

    const pieChart = {
        labels: ['Principle', 'Interest'],
        datasets: [
          {
            label: 'Principle to Interest',
            data: [homeValue, totalInterestGenerated],
            backgroundColor: [
              'rgba(237, 209, 85, 0.45)',
              'rgba(255, 255, 255, 0.65)',
            ],
            borderColor: [
              'rgb(248, 219, 87)',
              'rgb(255, 255, 255)'
            ],
            borderWidth: 1,
          },
        ],
      };

    return(
        <>
            <div className='chart-section'>
                <p className='chart-text'>
                    {paymentType} Payment: $ {paymentType == 'Monthly' ? monthlyPayment.toLocaleString(undefined, {maximumFractionDigits: 2}) : yearlyPayment.toLocaleString(undefined, {maximumFractionDigits: 2})}
                </p>
                <Pie className='pieChart' data={pieChart}></Pie>
            </div>  
        </>
            
    )
}

export default Result